"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const comparisons_1 = require("../../comparisons/comparisons");
const migration_1 = require("../../utils/migration");
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
const base_text_fieldtype_1 = require("../base-fields/base-text.fieldtype");
const text_field_validators_1 = require("./text-field.validators");
const validation_1 = require("../../validation/validation");
class TextFieldLogic extends base_text_fieldtype_1.BaseTextFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "textfield";
        this.label = (0, intl_1.$t)(texts_1.textFieldsText.text);
        this.icon = "text";
        this.iconColor = "#4ECCFD";
        this.placeholder = (0, intl_1.$t)(texts_1.textFieldsText.enter_text_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.textFieldsText.string),
            (0, intl_1.$t)(texts_1.textFieldsText.line),
        ];
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
            contains: comparisons_1.contains,
            not_contains: comparisons_1.notContains,
        };
        this.lookupMode = "lookup";
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = clipboard_1.textPasteRules;
        // @ts-expect-error: Need to resolve
        this.migrationRules = {
            textfield: (0, migration_1.clipboardToMigrate)(clipboard_1.clipboardAnyToText),
            textareafield: (0, migration_1.clipboardToMigrate)(clipboard_1.clipboardAnyToText),
            richtextareafield: (0, migration_1.clipboardToMigrate)(clipboard_1.textToDoc),
        };
    }
    get validators() {
        const uniqueValidator = (0, validation_1.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return { required: validation_1.required, max_length: text_field_validators_1.maxLength, unique: uniqueValidator };
    }
    getEmptyValue() {
        return "";
    }
    getInitialFieldValue(startValue) {
        return startValue || this.getEmptyValue();
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            deleteValueOnFirstKeypress: true,
            editorWidth: "100%",
        };
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            headerAlignment: "left",
        };
    }
    getCommonFieldParams(field) {
        return {
            ...super.getCommonFieldParams(field),
            unique: false,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison === "is" && filterValue) {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
}
exports.TextFieldLogic = TextFieldLogic;
